import videojs from 'video.js';
import vimmiPI from '../plugins/vimmiPI';
import AudioTracksSrv from '../services/audioTracksSrv';
import vjsSrv from 'src/js/services/vjsSrv';
import { normalizeLang } from 'vimmi-web-utils/cjs/normalizeLang';


let MenuItem = videojs.getComponent('MenuItem');
let CustomAudioTrackMenuItem = videojs.extend(MenuItem, {
  constructor: function(player, options) {
    MenuItem.apply(this, arguments);
    // this.hide();
    this.track = options.track;
  },
  handleClick: function(event) {
    MenuItem.prototype.handleClick.call(this, event);
    let items = this.player()
      .getChild('ControlBar')
      .getChild('CustomAudioTrackButton').items;
    items.map((item) => {
      item.selected(item.track === this.track);
    });
    let cur_audio_lang = vimmiPI.getActiveAsset().get('metadataLang');
    if (cur_audio_lang !== this.track) {
      vjsSrv.vjsPlayer.TechSrv.changeTrack({ id: this.track, language: this.track, type: 'custom' });
    }
  },
});


let MenuButton = videojs.getComponent('MenuButton');
let CustomAudioTrackButton = videojs.extend(MenuButton, {
  constructor: function() {
    MenuButton.apply(this, arguments);
    this.addClass('vjs-audio-button');
    this.addClass('custom-track');
    this.hide();
  },

  createItems: function(items) {
    if (items === void 0) {
      items = [];
    }
    if (vimmiPI.getActiveAsset()) {
      let tracks = vimmiPI.getActiveAsset().get('mAudio'); // tracks - Array<string>
      for (let i = 0; i < tracks.length; i++) {
        items.push(new CustomAudioTrackMenuItem(this.player_, {
          track: tracks[i],
          label: normalizeLang(tracks[i], 'name'),
          selected: vimmiPI.getActiveAsset().get('metadataLang') === tracks[i],
          selectable: true,
          multiSelectable: false,
        }));
      }
    }
    return items;
  },
});

videojs.registerComponent('CustomAudioTrackMenuItem', CustomAudioTrackMenuItem);
videojs.registerComponent('CustomAudioTrackButton', CustomAudioTrackButton);
